//Apps fields
export const apps = {
  image: {
    type: 'image',
    required: false,
    size: [600, 400],
  },
  name: 'apptokens:apps.fields.name',
  version: {
    trans: 'apptokens:apps.fields.version',
    required: false,
  },
  description: {
    trans: 'apptokens:apps.fields.description',
    type: 'textarea',
    required: false,
  },
  active: {
    trans: 'apptokens:apps.fields.active',
    type: 'switch',
    required: false,
  },
  authentication_redirect_url: {
    trans: 'apptokens:apps.fields.authentication_redirect_url',
    required: false,
  },
};

//Apptoken fields
export const apptokens = {
  id: 'apptokens:fields.id',
  name: {
    trans: 'apptokens:fields.name',
    required: false,
  },
  image: {
    label: null,
    type: 'image',
    size: [500,500],
    required: false,
  },
  description: {
    trans: 'apptokens:fields.description',
    required: false,
  },
  is_company: {
    trans: 'apptokens:fields.is_company',
    type: 'buttonselect',
    values: {
      0: 'apptokens:upgrade.type.user',
      1: 'apptokens:upgrade.type.company',
    },
  },
  company_name: {
    trans: 'apptokens:fields.company_name',
    required: false,
  },
  company_description: {
    trans: 'apptokens:fields.company_description',
    type: 'textarea',
    required: false,
  },
  company_contact_email: {
    trans: 'apptokens:fields.company_contact_email',
    inputType: 'email',
    required: false,
  },
  company_phone: {
    trans: 'apptokens:fields.company_phone',
    required: false,
  },
  company_website: {
    trans: 'apptokens:fields.company_website',
    required: false,
  },

  company_registered_address: {
    trans: 'apptokens:fields.company_registered_address',
    required: false,
  },
  company_registered_city: {
    trans: 'apptokens:fields.company_registered_city',
    required: false,
  },
  company_registered_zip: {
    trans: 'apptokens:fields.company_registered_zip',
    required: false,
  },
  company_registered_countries_id: {
    type: 'resource',
    resource: 'countries',
    trans: 'apptokens:fields.company_registered_countries_id',
    required: true,
  },

  company_billing_countries_id: {
    type: 'resource',
    resource: 'countries',
    trans: 'apptokens:fields.company_billing_countries_id',
    required: false,
  },
  company_billing_city: {
    trans: 'apptokens:fields.company_billing_city',
    required: false,
  },
  company_billing_address: {
    trans: 'apptokens:fields.company_billing_address',
    required: false,
  },
  company_billing_zip: {
    trans: 'apptokens:fields.company_billing_zip',
    required: false,
  },
  
  company_vat: {
    trans: 'apptokens:fields.company_vat',
    required: false,
  },
};


// WEBPACK FOOTER //
// ./src/sections/apptokens/fields.js